export default __webpack_public_path__ + "static/media/Gloves of the Bloodhunter.140f375d.jpg";